
@if (allCourses()){
  <div class="inner-section">
    <div class="header-course">
      <div>
        <span  class=" title-courses din-pro-condensed text-very-large black-color">{{allCourses()!.title}}</span>
      </div>

      <div class="progress-bar">
        @if (allCourses() && allCourses().completedLessons !== undefined) {
            @if (allCourses()!.completedLessons  === allCourses()!.totalLessons && allCourses().isCompleted && !allCourses().isCanCertDownload){
              <span class="count-progress-bar din-pro-simple-text text-medium black-color"> Вы прошли курс. Пройдите итоговое тестирование для получения сертификата.</span>
            }@else if(allCourses()!.completedLessons  == allCourses()!.totalLessons && allCourses().isCompleted && allCourses().isCanCertDownload){
              <span class="count-progress-bar din-pro-simple-text text-medium black-color">
                Поздравляем! <br/>
                Вы успешно прошли тест, для получения сертификата нажмите на кнопку</span>
          }
            @else{
              <span class="count-progress-bar din-pro-simple-text text-medium black-color"> {{allCourses()!.completedLessons}}/{{allCourses()!.totalLessons}} Видео</span>
              <p-progress-bar [value]="progressBarLessons"/>
            }
        }
      </div>


      @if (allCourses().completedLessons === 0 && !firstAviable()){
        <button (click)="startCourses()" class="button active" >Начать курс</button>
      } @else if (firstAviable()){
        <button (click)="goToLesson('bth')"  class="button active">Продолжить</button>
      } @else if (allCourses().completedLessons  == allCourses()!.totalLessons && allCourses().isCompleted && !allCourses().isCanCertDownload){
        <button (click)="globalTest()" class="button active">перейти к тесту</button>
      } @else if (allCourses()!.completedLessons  == allCourses()!.totalLessons && allCourses().isCompleted && allCourses().isCanCertDownload){
        <button (click)="sendSertificate()" class="button active">Получить сертификат</button>
      }

    </div>
    <div class="accordion-wrap">
      @for (module of allCourses()!.modules; track module; let i = $index){
        <div (click)="toggleModule(i)"
             [class.active-module]="openedIndexes.includes(i)" class="module-item-wrap ">
          <p [class.disable-modules]="module.isBlocked" class="module-item-title  din-pro-condensed">{{module.title}}</p>
          <img class="course-icon arrow-dropdown" [class.arrow-down]="!openedIndexes.includes(i)" src="../../../assets/icons/arrow.svg">
        </div>

        @if(openedIndexes.includes(i)){
          <ul class="module-wrap" [class.open]="openedIndexes.includes(i)">
            @for (lesson of module.lessons; track lesson){
              <li (click)="goToLesson(undefined,lesson.id)"
                  [class.disable]="lesson.isBlocked" class="module-item-wrap">
                <p  class="module-item-text din-pro-simple-text">{{lesson.title}}</p>
                @if (lesson.isCompleted){
                  <img class="course-icon" src="../../../assets/icons/success.svg">
                } @else if (lesson.isAvailable){
                  <img class="course-icon" src="../../../assets/icons/play.svg">
                }
                @else if (lesson.isBlocked){
                  <img class="course-icon" src="../../../assets/icons/locked.svg">
                }
              </li>
            }
           <button [class.disable]="module.totalLessons !== module.completedLessons"
                    [disabled]="module.totalLessons !== module.completedLessons"
                    (click)="goToTesting(i +1 )"
                    class="button default">перейти к вопросам
            </button>
          </ul>

        }
        <div class="line">
          <div class="accordion-title-line"></div>
        </div>
      }
    </div>
    <div class="questionnaire">
      <div class="title-course-block">
        <span class="title-courses din-pro-condensed text-very-large black-color">ПРОГРАММА НАСТАВНИЧЕСТВА "РАВНЫЙ – РАВНОМУ"</span>
        <img src="../../../assets/images/ui-kit-img/questionnaire.jpg" alt="questionnaire">
      </div>

      @if(!allCourses().isSurveyCompleted){

        <div class="title-anketa-wrap">
          <p class="module-item-text din-pro-simple-text title-anketa ">Уважаемые ветераны!</p>
          <p class="module-item-text din-pro-simple-text title-anketa ">  Набор на первый поток программы наставничества "Равный – равному" завершён.</p>
          <p class="module-item-text din-pro-simple-text title-anketa ">Благодарим за проявленный интерес. Информация о новых наборах будет опубликована на сайте – следите за новостями.</p>
        </div>
<!--        <button (click)="goToQuestionnaire()"-->
<!--                [class.disabled]="!allCourses().isCompleted"-->
<!--                [disabled]="!allCourses().isCompleted"-->
<!--                class="button active button-with-way-right">заполнить анкету</button>-->
      }@else{
        <p class="module-item-text din-pro-simple-text title-anketa ">Спасибо! Ваша заявка принята. В ближайшее время мы свяжемся с вами по указанной электронной почте.</p>
      }
    </div>
  </div>
}
